<div class="container mt-4">
  <div class="form-group">
    <label>Short Code</label>
    <input class="form-control" [(ngModel)]="STshortcode" [readonly]="isEditMode" />
  </div>
  <div class="form-group">
    <label>Name</label>
    <input class="form-control" [(ngModel)]="STName" />
  </div>
  <div class="form-group">
    <label>Remarks</label>
    <input class="form-control" [(ngModel)]="STRemarks" />
  </div>
  
  <div class="form-group" *ngIf=" !isEditMode">
    <label>Select Slide Layout</label>
    <select class="form-control" [(ngModel)]="selectedCustomLayout">
      <option value="">-- Select layout --</option>
      <option *ngFor="let customLayout of customLayouts" [value]="customLayout.LayoutShortCode">
        {{ customLayout.LayoutShortCode }} — {{ customLayout.LayoutDescription }}
      </option>
    </select>
  </div>
<div class="form-check" *ngIf="!isEditMode">
    <input class="form-check-input" type="checkbox" [(ngModel)]="useExistingLines" />
    <label class="form-check-label">Use lines from existing slide type</label>
  </div>
  <div class="form-group" *ngIf="useExistingLines && !isEditMode">
    <label>Select slide type</label>
    <select class="form-control" [(ngModel)]="selectedSlideType">
      <option value="">-- Select slide type --</option>
      <option *ngFor="let slideType of slideTypes" [value]="slideType.slideTypeShortcode">
        {{ slideType.slideTypeShortcode }} — {{ slideType.slideTypeName }}
      </option>
    </select>
  </div>

  
  <button class="btn btn-success" (click)="saveSlideType()">Save</button>
</div>


